import styled from "styled-components";
import { Spinner } from "../spinner/Spinner";
import { useIsMedia } from "src/apps/hooks/useIsMedia";

export const LoadingScreen = () => {
  const { isDesktop } = useIsMedia();
  const spinnerSize = isDesktop ? 16 : 12;

  return (
    <FullScreenContainer>
      <Spinner size={spinnerSize} />
    </FullScreenContainer>
  );
};

const FullScreenContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
